import { getToken } from '@verantos-dev/core-auth';
import { getBaseApiUrl, getGatewayApiVersion } from '@verantos-dev/core-constants';

/**
 * Auth-aware fetch for TanStack Query hooks in the gen-3 cohort detail page.
 * Mirrors the pattern in `feature-analytical-variables/src/lib/api/fetchers.ts`.
 *
 * Promotion candidate: once a third domain adopts TanStack reads, lift both
 * copies to `@verantos-dev/core-utils`. Keeping it local for now so the
 * `gen-3/` bucket stays self-contained and portable.
 */
export async function authFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const baseUrl = `${getBaseApiUrl()}/${getGatewayApiVersion()}`;
  const token = await getToken();

  const response = await fetch(`${baseUrl}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...init?.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status} ${response.statusText}`);
  }

  return response.json();
}
